import { render, staticRenderFns } from "./RegistrationReport.container.vue?vue&type=template&id=21e99dd7&scoped=true&"
import script from "./RegistrationReport.container.vue?vue&type=script&lang=js&"
export * from "./RegistrationReport.container.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationReport.container.vue?vue&type=style&index=0&id=21e99dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e99dd7",
  null
  
)

export default component.exports